import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const NumberOfActiveFilters = styled(Box)`
  ${({
    theme: {
      palette,
      colors,
      typography: { caption },
    },
  }) => `
    color: ${colors.golds.gold1};
    font-size: ${caption.fontSize};
    line-height: ${caption.lineHeight};
    background-color: ${palette.secondary.main};
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  `}
`;
